// extracted by mini-css-extract-plugin
module.exports = {"description":"ProductDetails_description__3dDCI"};